/* c8 ignore start */
import { SAT_SERVICE } from "@/utils/services";
import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable } = useFlag("SAT_CONTENT_MANAGER");
const { isFeatureAvailable: isSatCustomerReportManagerAvi } = useFlag(
  "SAT_CUSTOMER_REPORT_MANAGER",
);

const satPages = [
  {
    path: "overview",
    name: "customer-security_awareness_training-overview",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/overview/overview.index.vue"
      ),
  },
  {
    path: "sat_campaigns",
    name: "customer-security_awareness_training-sat_campaigns",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/sat-campaigns/campaigns.index.vue"
      ),
  },
  {
    path: "sat_campaigns/details",
    name: "customer-security_awareness_training-sat_campaigns-details",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/campaign-details/campaign-details.index.vue"
      ),
  },
];

const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: [
    {
      path: "security_awareness_training",
      name: "customer-security_awareness_training",
      component: () =>
        import(
          "@/modules/SecurityAwarnessTraining/views/Customer/customer.index.vue"
        ),
      redirect: {
        name: "customer-security_awareness_training-overview",
      },
      meta: {
        solutionId: SAT_SERVICE,
      },
      children: satPages,
    },
  ],
};

if (isFeatureAvailable.value) {
  customerRoutes.children[0].children.push({
    path: "content_manager",
    name: "customer-security_awareness_training-content_manager",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/content-manager/content-manager.index.vue"
      ),
  });
}

if (isSatCustomerReportManagerAvi.value) {
  customerRoutes.children[0].children.push({
    path: "report_manager",
    name: "customer-security_awareness_training-report_manager",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/report-manager/report-manager.index.vue"
      ),
  });
}

export { customerRoutes };

export default {};
/* c8 ignore end */
